export default function handleInputChange<T>(
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement |  HTMLSelectElement>,
  updateForm: React.Dispatch<React.SetStateAction<T>>
) {
  updateForm(prev => ({
    ...prev,
    [e.target.name]: e.target.value
  }))
}